import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

// ============================================================================
// LABEL COMPONENT - WELOOP DESIGN SYSTEM
// ============================================================================
// 📦 Base: shadcn/ui + Radix UI
// 🎨 Styling: WeLoop SCSS Design System
// Pure SCSS styling

interface LabelProps extends React.ComponentProps<typeof LabelPrimitive.Root> {
  size?: "default" | "sm" | "lg";
  required?: boolean;
  optional?: boolean;
}

function Label({
  className,
  size = "default",
  required = false,
  optional = false,
  children,
  ...props
}: LabelProps) {
  // Build className string manually without cn utility
  const labelClasses = [
    "wl-label",
    size !== "default" ? `wl-label-${size}` : "",
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <LabelPrimitive.Root data-slot="label" className={labelClasses} {...props}>
      {children}
      {required && <span className="wl-label-required">*</span>}
      {optional && <span className="wl-label-optional">(Optional)</span>}
    </LabelPrimitive.Root>
  );
}

export { Label };
export type { LabelProps };
